import DataLayer from './DataLayer';
import Gtm from '@grebban/gtm';
import type { Product } from '@activebrands/core-web/types/tracking-events';

export default ({ currencyCode, product }: {
    currencyCode: string;
    product: Product;
}) => {
    Gtm.addDataLayerEvent('product_view', {
        ecommerce: {
            currencyCode,
            detail: {
                products: [DataLayer.getProduct(product)],
            },
        },
    });
};
